import React from 'react';
import StyledCheckBoxArea from '../../../../style/Safety/DamageReport/StyledCheckBoxArea';
import { CHASSIS_DAMAGE_CHECKBOX_OPTION_LIST } from '../../../../constant/Safety/DamageReport/options';
import CommonDamageCheckBox from '../CommonDamageCheckBox';
import { handleInputChange } from '../../../../util/Safety/DamageReport/Handler/changedInputHandler';
import {
  OTHER_INPUT_STYLE,
  STYLE_CHASSIS_STATUS_CHECKBOX_AREA,
} from '../../../../style/Safety/DamageReport/styles';
import CustomTextarea from '../../../Common/Controller/Textarea/Custom';
import CommonTextarea from '../../../Common/Controller/Textarea';
import { changeText } from '../../../../util/Safety/Common/Handler/controllerChangeHandler';

const ChassisDamagedInfoFields = ({
  isCompleted,
  damageReport,
  isEditable,
}) => {
  return (
    <div className="w-full mt-[-1px] flex flex-col gap-y-[16px]">
      <StyledCheckBoxArea styles={{ ...STYLE_CHASSIS_STATUS_CHECKBOX_AREA }}>
        <CommonDamageCheckBox
          options={CHASSIS_DAMAGE_CHECKBOX_OPTION_LIST}
          disabled={isCompleted || !isEditable}
          gapBetweenX="gap-x-[59px]"
        />
        <div className="flex mt-[16px] items-center gap-x-[7px]">
          <CustomTextarea
            label="Other"
            inputName="ch_others"
            maxLength={120}
            suppressErrorVisible
            suppressErrorContentVisible
            styles={OTHER_INPUT_STYLE}
            disabled={isCompleted || !isEditable}
            onChange={handleInputChange}
            defaultValue={damageReport?.ch_others || ''}
            suppressCountVisible
          />
        </div>
      </StyledCheckBoxArea>
      <div>
        <CommonTextarea
          label="REMARKS"
          inputName="remarks"
          maxLength={120}
          onChangeHandler={changeText}
          defaultValue={damageReport?.remarks || ''}
          disabled={!isEditable}
          height="h-[80px]"
        />
      </div>
    </div>
  );
};

export default ChassisDamagedInfoFields;
